import APIClient from '@/shared/http/clients/api'

const APIPci = process.env.APIBaseURLPci
const resourceName = 'pciPreLayout'

const GetAll = (data = {}, config = {}) => APIClient.get(`${APIPci}/${resourceName}`, data, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APIPci}/${resourceName}`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APIPci}/${resourceName}`, data, config)
const Delete = (id = '', config = {}) => APIClient.delete(`${APIPci}/${resourceName}/${id}`, config)

const PCIPreLayoutRepository = {
  GetAll,
  Create,
  Update,
  Delete
}

export default PCIPreLayoutRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/pci/pciprelayout.js